import { Search } from "@raresail/react-ionicons";
import { CardIcon } from "../../assets/svg/Svgs";
import {
  IconBox,
  ListItemWrapper,
  StatusTag,
} from "../../components/elements/Elements";
import { API_TRANSACTIONS } from "../../constants/apis";
import {
  COMPLETED,
  DATE,
  DATE_TIME_FORMAT,
  DEPOSIT,
  FAILED,
  PENDING,
  SELECT,
  TEXT,
} from "../../constants/constants";
import {
  addSelectOption,
  currencyFormat,
  formatDate,
  numberFormat,
} from "../../utils/helpers";
import { openBottomSheet } from "../../utils/modalUtils";
import { searchFilterField } from "../../constants/options";

export const useTransactionsList = () => {
  const listData = (data: any[]) => {
    return data.map((val) => {
      const row = {
        ...val,
      };
      return row;
    });
  };

  const filters = [
    searchFilterField,
    {
      field: "transaction_type",
      type: SELECT,
      options: ["withdrawal", DEPOSIT].map((v) => addSelectOption(v)),
    },
    {
      field: "status",
      type: SELECT,
      options: [PENDING, COMPLETED, FAILED].map((v) => addSelectOption(v)),
    },
    {
      field: "min_date",
      type: DATE,
    },
    {
      field: "max_date",
      type: DATE,
    },
  ];

  return {
    ListItem: TransactionItem,
    api: API_TRANSACTIONS,
    listData,
    filters,
  };
};

export const TransactionItem = ({ data }: { data: any }) => {
  const {
    status,
    description,
    transaction_type,
    amount,
    currency,
    reference_number,
    transaction_date,
  } = data || {};

  return (
    <ListItemWrapper
      className="flexNullCenter gap15"
      onClick={() =>
        openBottomSheet({
          component: "details",
          title: "Transaction Details",
          data: {
            reference_number,
            status: <StatusTag status={status} />,
            transaction_type,
            description,
            amount: currencyFormat(amount, currency),
            transaction_date: formatDate(transaction_date, DATE_TIME_FORMAT),
          },
        })
      }
    >
      {/* ICON */}
      <IconBox icon={CardIcon} size={20} />

      {/* MID */}
      <div className="flexGrow">
        <div className="semiBold textDark font13 capitalize">
          {transaction_type}
        </div>
        {/* <div className="font11 main">{stringify(reference_number)}</div> */}
        <div className="font11 main ellipsis">{description}</div>
        <div className="font10 grey">{formatDate(transaction_date)}</div>
      </div>

      {/* END */}
      <div className="textEnd">
        <div className="semiBold textDark font13 mb5">
          UGX {numberFormat(amount)}
        </div>
        <StatusTag status={status} />
      </div>
    </ListItemWrapper>
  );
};
